import React from "react";
import { Box, Typography } from "@mui/material";
import PillCheckbox from "../../../Components/PillCheckbox";

const REMARKS_MAX = 1000;

// Required remarks (live counter) + approval acknowledgment checkbox.
//
// label / maxLength / placeholder / showAcknowledgement are props rather than constants
// so the Edit Pack Details screen can reuse this section as-is instead of standing up a
// second remarks field beside it. Every default reproduces the replacement flow's
// original markup exactly, so that caller is byte-identical.
export default function RemarksSection({
    remarks = "",
    acknowledged = false,
    errors = {},
    onRemarksChange = () => {},
    onAcknowledgedChange = () => {},
    label = "Remarks",
    maxLength = REMARKS_MAX,
    placeholder = "Fill out any additional remarks here",
    showAcknowledgement = true,
    testId = "remarks-input",
}) {
    return (
        <Box>
            <Typography sx={{ fontSize: "15px", fontWeight: 600, color: "#1A1A1A", mb: "8px" }}>
                {label}<span style={{ color: "#E5484D", marginLeft: 2 }}>*</span>
            </Typography>

            <Box sx={{ position: "relative" }}>
                <textarea
                    data-testid={testId}
                    value={remarks}
                    maxLength={maxLength}
                    onChange={(e) => onRemarksChange(e.target.value)}
                    placeholder={placeholder}
                    rows={5}
                    style={{
                        width: "100%",
                        resize: "vertical",
                        borderRadius: "8px",
                        border: `1px solid ${errors.remarks ? "#E5484D" : "#E0E0E0"}`,
                        padding: "12px 14px",
                        fontSize: "14px",
                        fontFamily: "inherit",
                        color: "#2E2E2E",
                        outline: "none",
                        boxSizing: "border-box",
                    }}
                />
                <Typography
                    sx={{
                        position: "absolute",
                        right: "12px",
                        bottom: "10px",
                        fontSize: "12px",
                        color: "#A0A0A0",
                    }}
                >
                    {remarks.length} / {maxLength}
                </Typography>
            </Box>
            {errors.remarks && (
                <Typography sx={{ fontSize: "12px", color: "#E5484D", mt: "4px" }}>
                    {typeof errors.remarks === "string"
                        ? errors.remarks
                        : "Please add remarks"}
                </Typography>
            )}

            {showAcknowledgement && (
            <Box sx={{ mt: "12px" }}>
                <PillCheckbox
                    plain
                    testId="acknowledge-checkbox"
                    checked={acknowledged}
                    onChange={(e) => onAcknowledgedChange(e.target.checked)}
                    label="I acknowledge that approval has been taken for this battery pack replacement."
                    labelSize={14}
                    labelWeight={500}
                />
                {errors.acknowledged && (
                    <Typography sx={{ fontSize: "12px", color: "#E5484D", mt: "4px" }}>
                        Please acknowledge and tick the checkbox
                    </Typography>
                )}
            </Box>
            )}
        </Box>
    );
}
